import { StyledButton } from '../../Atoms/Button/styles'
import { StyledCard } from '../../Molecules/Card/styles'
import { StyledGrid } from '../../Molecules/Grid/styles'
import { fadeIn, translateDown } from '../../Styles/keyframes'
import { createAnimation, styled } from '../../Styles/stitches.config'

export const ImageWrapper = styled('div', {
    w: '100%',
    maxW: 80,

    '@mobile': {
        py: '$2',
        pl: '$2',
    },

    '@desktop': {
        mt: 32,
    },
    variants: {
        disabled: {
            true: {
                bc: '$primary400',
                opacity: 0.5,
                color: '$primary400',
                pointerEvents: 'none',
            },
        },
    },
})

export const StyledServiceCard = styled(StyledCard, {
    bgc: '$primary200',
    color: '$primary600',

    [`& ${StyledButton}`]: {
        alignSelf: 'end',
        bgc: '$primary600',
        br: 0,
        color: '$primary200',
        w: '100%',

        '&:disabled': {
            bgc: '$primary400',
            bc: '$primary400',
            color: '$primary200',
        },
    },

    '&:hover': {
        bgc: '$primary300',

        [`& ${StyledButton}:enabled`]: {
            bc: '$primary600',
            bgc: '$primary600',
            color: '$primary300',
            opacity: 1,
        },
    },

    '@mobile': {
        gap: '$3',
        gridAutoFlow: 'column',
        gridTemplateColumns: '55px 1fr auto',
        justifyItems: 'initial',

        [`& ${StyledButton}`]: {
            fontSize: 0,
            h: '100%',
            px: '$1',

            svg: {
                fontSize: 20,
            },
        },
    },

    '@desktop': {
        gridAutoFlow: 'row',
        gap: 28,

        [`& ${StyledButton}`]: {
            border: 'none',
            fontSize: 20,

            svg: {
                display: 'none',
            },
        },

        [`& ${StyledGrid}`]: {
            gap: '$2',
            px: '$3',
            textAlign: 'center',
        },
    },

    variants: {
        disabled: {
            true: {
                bc: '$primary400',
                color: '$primary400',
                pointerEvents: 'none',
            },
        },
    },
})

export const CoverageButton = styled('div', {
    display: 'grid',

    [`& ${StyledButton}`]: {
        ...createAnimation([fadeIn, translateDown]),
        bc: '$primary600',
        bgc: '$white',
        color: '$primary600',
        p: 4,

        '@desktop': {
            borderTop: 0,
            br: '0px 0px $1 $1',
            h: 'min-content',
            justifySelf: 'center',
            w: '90%',
        },

        '&:hover': {
            bgc: '$primary600',
            color: '$white',
        },
    },
})

export const ServiceCardContainer = styled('div', {
    display: 'grid',

    '@mobile': {
        gap: '$1',
    },
})
